// extracted by extract-css-chunks-webpack-plugin
module.exports = {"newText":"_2zCWea","sparkle":"_3dY9Q5"};